import React from 'react'
import { Mutation } from 'react-apollo'
import { CREATE_PAIN_RATING_MUTATION } from '../../mutations/CREATE_PAIN_RATING_MUTATION'
import { CreatePainRatingMutation, CreatePainRatingMutationVariables } from '../../schema/schemaTypes'
import { PainRatingView } from './PainRatingView'

export const PainRatingContainer = () => (
  <Mutation<CreatePainRatingMutation, CreatePainRatingMutationVariables> mutation={CREATE_PAIN_RATING_MUTATION}>
    {(createPainRating, { data, error }) =>
      <PainRatingView createPainRating={createPainRating} data={data} error={error} />}
  </Mutation>
)



// WEBPACK FOOTER //
// ./src/organisms/PainRating/PainRatingContainer.tsx